import {SecurityQuestion} from '../../my-profile/model/security-question';

export class SqResetPassword {
  userName: null;
  newPassword: null;
  oldPassword: null;
  securityQuestions: SecurityQuestion[];
  validate: null;
}
